const Custom = {
    install(Vue, options) {
        Vue.mixin({
            data: () => ({
                fontAwesomeDefaultStyle: "fad",
                pageFilters: []
            }),
            methods: {
                calculateDistanceMatrix: function(from, to, mapRef) {
                    var origin = { lat: from.lat, lng: from.lng };
                    var destination = { lat: to.lat, lng: to.lng };

                    var service = new google.maps.DistanceMatrixService();
                    service.getDistanceMatrix(
                        {
                            origins: [origin],
                            destinations: [destination],
                            travelMode: "DRIVING",
                            drivingOptions: {
                                departureTime: new Date()
                            }
                        },
                        (response, status) => {
                            if (status == "OK") {
                                var results = response.rows[0].elements;
                                var element = results[0];
                                var distance = element.distance.value;
                                var duration = element.duration.value;
                                var traffic = element.duration_in_traffic.value;
                                console.log(element);
                                this.$refs[mapRef].setDetails(distance);
                                this.$refs[mapRef].setTimeEstimate(duration);
                                this.$refs[mapRef].setTimeOptimistic(traffic);
                            }
                        }
                    );
                },
                calculateDistanceMatrixTrafficPessimistic: function(
                    from,
                    to,
                    mapRef
                ) {
                    var origin = { lat: from.lat, lng: from.lng };
                    var destination = { lat: to.lat, lng: to.lng };

                    var service = new google.maps.DistanceMatrixService();
                    service.getDistanceMatrix(
                        {
                            origins: [origin],
                            destinations: [destination],
                            travelMode: "DRIVING",
                            drivingOptions: {
                                trafficModel: "pessimistic",
                                departureTime: new Date()
                            }
                        },
                        (response, status) => {
                            if (status == "OK") {
                                var results = response.rows[0].elements;
                                var element = results[0];
                                console.log(element);
                                var traffic = element.duration_in_traffic.value;
                                this.$refs[mapRef].setTimePessimistic(traffic);
                            }
                        }
                    );
                },
                placeMarker: function(place, mapRef, modalRef = null) {
                    if (!!modalRef) var map = this.$refs[modalRef][mapRef];
                    else var map = this.$refs[mapRef];
                    map.placeMarker(place);
                },
                addDirection: function(from, to, mapRef) {
                    this.$refs[mapRef].addDirection(from, to);
                },
                moveToMarker: function(place, mapRef = "map") {
                    this.$refs[mapRef].moveToMarker(place);
                },
                emptyObject: function(object) {
                    return object === null || Object.keys(object).length === 0;
                },
                stopToMapObject: function(stop) {
                    return {
                        address: stop.address,
                        formatted_address: stop.address,
                        lat: parseFloat(stop.latitude),
                        lng: parseFloat(stop.longitude),
                        notes: stop.notes
                    };
                },
                mapMounted: function(...components) {
                    components.forEach(
                        item => this.$refs[item].onMapReady(),
                        this
                    );
                },

                HSVtoRGB: function(h, s, v) {
                    var r, g, b, i, f, p, q, t;
                    if (arguments.length === 1) {
                        (s = h.s), (v = h.v), (h = h.h);
                    }
                    i = Math.floor(h * 6);
                    f = h * 6 - i;
                    p = v * (1 - s);
                    q = v * (1 - f * s);
                    t = v * (1 - (1 - f) * s);
                    switch (i % 6) {
                        case 0:
                            (r = v), (g = t), (b = p);
                            break;
                        case 1:
                            (r = q), (g = v), (b = p);
                            break;
                        case 2:
                            (r = p), (g = v), (b = t);
                            break;
                        case 3:
                            (r = p), (g = q), (b = v);
                            break;
                        case 4:
                            (r = t), (g = p), (b = v);
                            break;
                        case 5:
                            (r = v), (g = p), (b = q);
                            break;
                    }
                    return {
                        r: Math.round(r * 255),
                        g: Math.round(g * 255),
                        b: Math.round(b * 255)
                    };
                },
                RGBToHex: function({ r, g, b }) {
                    r = r.toString(16);
                    g = g.toString(16);
                    b = b.toString(16);

                    if (r.length == 1) r = "0" + r;
                    if (g.length == 1) g = "0" + g;
                    if (b.length == 1) b = "0" + b;

                    return "#" + r + g + b;
                },
                randomColor: function() {
                    var golden_ratio_conjugate = 0.618033988749895;
                    var h = Math.random();
                    h += golden_ratio_conjugate;
                    h = h % 1;
                    var color = this.HSVtoRGB(h, 0.75, 0.8);
                    return this.RGBToHex(color);
                },
                updateFilters: function(
                    values,
                    tableRef = null,
                    mapRef = null
                ) {
                    var id = values.id;
                    var filter = this.pageFilters.find(item => item.id == id);
                    if (!!filter) filter.value = values.value;
                    else this.pageFilters.push(values);
                    if (!!tableRef) {
                        this.$refs[tableRef].updateFilter(
                            "EQUALS",
                            values.id,
                            values.value
                        );
                    }
                },
                removeFilters: function(id, tableRef) {
                    var filter = this.pageFilters.findIndex(
                        item => item.id == id
                    );
                    if (filter >= 0) this.pageFilters.splice(filter, 1);
                    if (!!tableRef) {
                        this.$refs[tableRef].updateFilter("EQUALS", id, null);
                    }
                },
                submitSearchTable: function(tableRef) {
                    this.$refs[tableRef].filter();
                },
                submitSearchMap: function(mapRef) {
                    this.$refs[mapRef].submitSearch();
                },
                formatStatusRouteTableCell: function(item, row, meta) {
                    if (!!item) {
                        return {
                            name: "font-awesome-icon",
                            props: {
                                icon: ["fad", "check-square"],
                                class: {
                                    "text-success": true
                                }
                            },
                            title: "Approvata"
                        };
                    } else {
                        return {
                            name: "font-awesome-icon",
                            props: {
                                icon: ["fad", "minus-square"],
                                class: {
                                    "text-light": true
                                }
                            },
                            title: "Non approvata"
                        };
                    }
                }
            }
        });
    }
};

export default Custom;
